export function formatFileSize(sizeInKB) {
  if (sizeInKB === 0) return '0 KB';
  const sizes = ['KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(sizeInKB) / Math.log(1024));
  const index = Math.min(Math.max(i, 0), sizes.length - 1);
  const value = sizeInKB / Math.pow(1024, index);
  return "".concat(value % 1 === 0 ? value.toFixed(0) : value.toFixed(1), " ").concat(sizes[index]);
}